import { render, staticRenderFns } from "./OverallSalesByWeek.vue?vue&type=template&id=2520380b&scoped=true"
import script from "./OverallSalesByWeek.vue?vue&type=script&lang=js"
export * from "./OverallSalesByWeek.vue?vue&type=script&lang=js"
import style0 from "./OverallSalesByWeek.vue?vue&type=style&index=0&id=2520380b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520380b",
  null
  
)

export default component.exports